import { Component, Input, OnInit } from "@angular/core";
import { DemoInstance, PowerState, ProvisioningState } from "src/app/core";
import { AdminGridColumnsFactory } from "src/app/shared/admin-grid/admin-grid-columns-factory";
import { IntendedUseEnum, boardIntendedUses, partnerIntendedUses } from "src/app/core/model/IntendedUses";
import { UserService } from "src/app/services/user.service";
import { Column } from "devextreme/ui/data_grid";

interface DemoInstanceGrid {
  title: string;
  link: string;
  isActive: boolean;
  owner: string;
  templateSuggested: boolean;
  powerState: PowerState;
  expirationDate?: Date;
  intendedUse: IntendedUseEnum | null;
  regionName: string;
  comment: string;
}

@Component({
  selector: "brd-instance-grid",
  templateUrl: "./instance-grid.component.html",
  styleUrl: "./instance-grid.component.less",
  standalone: false
})
export class InstanceGridComponent implements OnInit {
  @Input() instances!: DemoInstance[];

  instancesGrid: DemoInstanceGrid[];
  columns: Column[];

  constructor(private userService: UserService) {
    const uses = this.userService.isBoardUser() ? boardIntendedUses : partnerIntendedUses;
    const intendedUses = [
      {
        id: IntendedUseEnum.internalUse,
        name: "Internal Use"
      },
      ...uses
    ];
    this.columns = [
      AdminGridColumnsFactory.createTextColumn(
        { fieldName: "title", caption: "Demo Title" },
        {
          cellTemplate: "instanceName"
        }
      ),
      AdminGridColumnsFactory.createTextColumn({ fieldName: "owner", caption: "Creator" }),
      AdminGridColumnsFactory.createTextColumn(
        { fieldName: "type", caption: "Type" },
        {
          calculateCellValue: (data: DemoInstance) => (data.templateSuggested ? "Suggested" : "Custom")
        }
      ),
      AdminGridColumnsFactory.createTextColumn(
        { fieldName: "powerState", caption: "Status" },
        {
          calculateCellValue: (data: DemoInstance) => {
            switch (data.powerState) {
              case PowerState.Online:
                return "Active";
              case PowerState.Offline:
                return "Sleep";
              default:
                return data.powerState;
            }
          }
        }
      ),
      AdminGridColumnsFactory.createDateTimeColumn({ fieldName: "expirationDate", caption: "Expiration date" }),
      AdminGridColumnsFactory.createLookupColumn({
        fieldName: "intendedUse",
        caption: "Intended use",
        lookup: {
          dataSource: intendedUses,
          valueExpr: "id",
          displayExpr: "name"
        }
      }),
      AdminGridColumnsFactory.createTextColumn({ fieldName: "regionName", caption: "Region" }),
      AdminGridColumnsFactory.createTextColumn({ fieldName: "comment", caption: "Note" })
    ];
  }

  ngOnInit(): void {
    this.instancesGrid = this.instances.map(instance => ({
      title: instance.title,
      link: instance.link,
      isActive:
        instance.available && instance.powerState === PowerState.Online && instance.provisioningState === ProvisioningState.Completed,
      owner: instance.owner,
      templateSuggested: instance.templateSuggested,
      powerState: instance.powerState,
      expirationDate: instance.expirationDate,
      intendedUse: instance.intendedUse,
      regionName: instance.regionName,
      comment: instance.prospect
    }));
  }

  openWindow(instance: DemoInstanceGrid): void {
    if (instance.isActive) window.open(instance.link, "_blank");
  }
}
